import { render, staticRenderFns } from "./DYDetails.vue?vue&type=template&id=742890f6&scoped=true&"
import script from "./DYDetails.vue?vue&type=script&lang=js&"
export * from "./DYDetails.vue?vue&type=script&lang=js&"
import style0 from "./DYDetails.vue?vue&type=style&index=0&id=742890f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742890f6",
  null
  
)

export default component.exports